export const ContextMenuConstants = {
    MAKE_MENU_VISIBLE: "MAKE_MENU_VISIBLE", 
    MAKE_MENU_INVISIBLE: "MAKE_MENU_INVISIBLE"
} 


